// Keep the build refund consistent across pricing, FAQs and the fit calculator.
export const BUILD_REFUND_SHARE = 0.7;
export const BUILD_REFUND_PERCENT = Math.round(BUILD_REFUND_SHARE * 100);
